/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Controls how selection options tied to an allowance group are handled when copied.0 = SameJobGroup

1 = Standalone

2 = NewAllowance


 */
export type AllowanceCopyBehavior =
  (typeof AllowanceCopyBehavior)[keyof typeof AllowanceCopyBehavior];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllowanceCopyBehavior = {
  SameJobGroup: 0,
  Standalone: 1,
  NewAllowance: 2,
} as const;
